import './index.css';

import React from 'react';
import { ConfigProvider, Tag, Tooltip, Typography } from '@duxton-web/ui';

import DeleteButton from './delete';
import Editor from './editor';
import ReorderButtonGroup from './reorder';
import { RolloutTarget } from '@/lib/PlannerDTOs';
import { getRolloutTargetName } from '@/utils/rollout';

export interface RolloutTitleProps {
  rolloutIndex: number;
  disabled?: boolean;
  showReorderButtons?: boolean;
  deleteBlock: (index: number) => any;
  onReorderUpClick: () => void;
  onReorderDownClick: () => void;
  rolloutTarget: RolloutTarget;
  onRolloutTargetIndexChange: (fromIndex: number, toIndex: number) => void;
  maxPosition: number;
  isReordered: (rolloutTarget) => boolean;
  isGlobal?: boolean;
}

export default function RolloutTitle({
  rolloutIndex,
  disabled,
  showReorderButtons,
  deleteBlock,
  onReorderUpClick = () => {},
  onReorderDownClick = () => {},
  rolloutTarget,
  onRolloutTargetIndexChange,
  maxPosition,
  isReordered,
}: RolloutTitleProps) {
  const rolloutTargetName = getRolloutTargetName(rolloutTarget.constraints);

  return (
    <div
      style={{ display: 'flex', alignItems: 'center', gap: 4, width: '100%' }}
    >
      <Tooltip title={rolloutTarget?.id}>
        <Tag color="white">{rolloutIndex + 1}</Tag>
      </Tooltip>
      <div
        style={{
          flexGrow: 1,
          flexShrink: 1,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          marginRight: 8,
        }}
      >
        <Typography.Text ellipsis>{rolloutTargetName}</Typography.Text>
      </div>
      <ConfigProvider
        theme={{
          components: {
            Button: {
              defaultBorderColor: '#d9d9d9',
            },
          },
        }}
      >
        <div
          className="rollout-title__icon-container"
          style={{
            display: 'flex',
            flex: '0 0 auto',
            alignItems: 'center',
            gap: 4,
          }}
        >
          <Editor
            rolloutTargetIndex={rolloutIndex + 1}
            rolloutTarget={rolloutTarget}
            onChange={onRolloutTargetIndexChange}
            disabled={disabled || showReorderButtons}
            maxPosition={maxPosition}
            isReordered={isReordered ? isReordered(rolloutTarget) : false}
          />
          <ReorderButtonGroup
            rolloutIndex={rolloutIndex}
            disabled={!showReorderButtons}
            onReorderUpClick={onReorderUpClick}
            onReorderDownClick={onReorderDownClick}
          />
          <DeleteButton
            rolloutTarget={rolloutTarget}
            rolloutIndex={rolloutIndex}
            disabled={disabled || showReorderButtons}
            deleteBlock={deleteBlock}
          />
        </div>
      </ConfigProvider>
    </div>
  );
}
